export const SET_VARIANT = 'setVariant'
